(function () {
  console.log('Initializing CSRF token...');
  window.compliance || (window.compliance = {});
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  if (metaTag) {
    window.compliance.token = metaTag.content;
    console.log('CSRF token initialized:', window.compliance.token ? 'Token found' : 'Token empty');
  } else {
    console.warn('CSRF token meta tag not found');
  }
})();
